<template>
  <div class="container text-center">
    <h1>404</h1>
    <hr />
    <br />
    The page you are looking for is lost in the fields.
    <div class="center">
      <Button
        size="large"
        label="Go back home"
        @click="$router.push('/')"
      />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'

export default {
  name: 'NotFound',
  components: {
    Button
  },
  mounted: function () {
    this.changeTitle('404')
  }
}
</script>
